import type { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export enum NonTypeTab {
  ALL = 'all',
}

export type TemplateTab = DevelopmentTool | NonTypeTab;
